import ApiService from "../ApiService";
// import { StorageService } from "../StorageService"; // si no lo usas, puedes quitarlo

const medicinesClientService = {
  // GET /medicines-client/
  getAll(params) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/medicines-client/`,
      method: "get",
      params, // opcional: filtros/paginación
    });
  },

  // GET /medicines-client/:id
  getOne(id) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/medicines-client/${id}`,
      method: "get",
    });
  },


  // POST /medicines-client/save/
  create(data) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/medicines-client/save/`,
      method: "post",
      data,
    });
  },

  // PUT /medicines-client/:id
  update(id, data) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/medicines-client/${id}`,
      method: "put",
      data,
    });
  },

  // DELETE /medicines-client/remove/:id
  remove(id) {
    return ApiService.customRequest({
      url: `${process.env.VUE_APP_ROOT_API}/medicines-client/remove/${id}`,
      method: "delete",
    });
  },
};

export default medicinesClientService;
